import { Component } from '@verndale/core';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';


Swiper.use([Navigation]);

class ProductGallery extends Component {
  imagesCount: number;
  swiper: Swiper;

  constructor(el: HTMLElement) {
    super(el);
    this.imagesCount = 0;

    this.init();
    this.buildGalleryLightBox();
  }


  setupDefaults() {
    this.dom = {
      inner: this.el.querySelector<HTMLElement>('.product-detail__gallery-inner')
    };
  }

  init() {
    this.imagesCount = (this.dom.inner as HTMLElement).querySelectorAll('img').length;

    (this.dom.inner as HTMLElement).querySelectorAll('img').forEach((image, index) => {
      const button = document.createElement('button');
      button.classList.add('product-detail__gallery-item');
      button.dataset.index = index.toString();
      button.appendChild(image);
      (this.dom.inner as HTMLElement).appendChild(button);
    });

    this.dom.galleryItems = (this.dom.inner as HTMLElement).querySelectorAll(
      '.product-detail__gallery-item'
    );

    if (this.imagesCount > 6) {
      const overlay = document.createElement('div');
      overlay.classList.add('product-detail__gallery-item-overlay');
      const totalCount = this.imagesCount - 6;
      const label = (this.el.dataset.viewMoreLabel as string).replace('[count]', totalCount.toString());

      overlay.innerHTML = `<span>${label}</span>`;
      const lastImage = this.dom.galleryItems[5];
      lastImage.appendChild(overlay);
      (this.dom.inner as HTMLElement).dataset.imagesCount = '6';
    } else {
      (this.dom.inner as HTMLElement).dataset.imagesCount = this.imagesCount.toString();
    }

    (this.dom.inner as HTMLElement).dataset.initialized = 'initialized';
  }

  buildGalleryLightBox() {
    this.dom.lightbox = document.createElement('dialog');
    this.dom.lightbox.classList.add('product-detail__gallery-lightbox');
    this.dom.lightbox.innerHTML = `
      <div class="product-detail__gallery-lightbox-inner">
        <button class="product-detail__gallery-lightbox-close" autofocus>
          <svg role="presentation">
            <use xlink:href="#modal-close" />
          </svg>
        </button>
        <div class="product-detail__gallery-lightbox-content">
          ${
      this.imagesCount > 0
        ? `<div role="button" class="product-detail__gallery-lightbox-prev">
            <svg role="presentation">
              <use xlink:href="#modal-chevron-left" />
            </svg>
          </div>`
        : ''
    }
          <div class="swiper-container">
            <div class="swiper-wrapper"></div>
          </div>
          ${
      this.imagesCount > 0
        ? `<div role="button" class="product-detail__gallery-lightbox-next">
            <svg role="presentation">
              <use xlink:href="#modal-chevron-right" />
            </svg>
          </div>`
        : ''
    }
          ${
      this.imagesCount > 0
        ? '<div class="product-detail__gallery-lightbox-pagination"></div>'
        : ''
    }
        </div>
      </div>
    `;

    document.body.appendChild(this.dom.lightbox);
    const sliderContainer = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-content .swiper-container'
    );
    const swiperWrapper = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-content .swiper-wrapper'
    );

    this.dom.lightboxClose = this.dom.lightbox.querySelector<HTMLElement>(
      '.product-detail__gallery-lightbox-close'
    );
    this.dom.lightboxInner = this.dom.lightbox.querySelector<HTMLElement>(
      '.product-detail__gallery-lightbox-inner'
    );
    this.dom.lightboxPagination = this.dom.lightbox.querySelector<HTMLElement>(
      '.product-detail__gallery-lightbox-pagination'
    );

    (this.dom.inner as HTMLElement).querySelectorAll('img').forEach((image) => {
      const swiperSlide = document.createElement('div');
      swiperSlide.classList.add('swiper-slide');
      swiperSlide.appendChild(image.cloneNode(true));
      (swiperWrapper as HTMLElement).appendChild(swiperSlide);
    });

    this.swiper = new Swiper(sliderContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: (this.dom.lightboxInner as HTMLElement).querySelector<HTMLElement>(
          '.product-detail__gallery-lightbox-next'
        ),
        prevEl: (this.dom.lightboxInner as HTMLElement).querySelector<HTMLElement>(
          '.product-detail__gallery-lightbox-prev'
        )
      },
      on: {
        update: (swiper: Swiper) => {
          (this.dom.lightboxPagination as HTMLElement).innerHTML = `${swiper.activeIndex + 1}/${
            swiper.slides.length
          }`;
        },
        slideChange: (swiper: Swiper) => {
          (this.dom.lightboxPagination as HTMLElement).innerHTML = `${swiper.activeIndex + 1}/${
            swiper.slides.length
          }`;
        }
      }
    });

    (this.dom.lightboxClose as HTMLElement).addEventListener(
      'click',
      this.closeGalleryLightBox.bind(this)
    );
    this.dom.lightbox.addEventListener(
      'click',
      this.handleClickOutside.bind(this)
    );
    (this.dom.galleryItems as NodeList).forEach((item) => {
      item.addEventListener('click', this.displayGalleryLightBox.bind(this));
    });
  }

  displayGalleryLightBox(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const index = target.dataset.index;

    this.swiper.slideTo(index);
    (this.dom.lightbox as HTMLDialogElement).show();
    this.swiper.update();
  }

  closeGalleryLightBox() {
    (this.dom.lightbox as HTMLDialogElement).close();
  }

  handleClickOutside(event: Event) {
    const target = event.currentTarget as HTMLElement;
    if (
      event.target === this.dom.lightbox &&
      !(this.dom.lightboxInner as HTMLElement).contains(target)
    ) {
      this.closeGalleryLightBox();
    }
  }
}

export default ProductGallery;
